import { Col, Image, Row, Table, Tag, Typography } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import favIconUrl from "assets/Images/loadingImage.png";
import SkeltonCartSvg from "assets/Images/SkeltonCardLogo.svg";
import { FC, useEffect, useState } from "react";
import { useGetInvoiceDetails } from "../../ServerSideStates";

import React from "react";

import PriceFormatter from "apps/Common/PriceFormatter";
import useWindowSize from "helpers/useWindowSize";

type PriceDisplayProps = {
  price: number;
  priceWithDiscount?: number;
};

const PriceDisplay: React.FC<PriceDisplayProps> = ({
  price,
  priceWithDiscount,
}) => {
  const { Text } = Typography;

  return (
    <div>
      {priceWithDiscount !== undefined &&
      priceWithDiscount > 0 &&
      priceWithDiscount !== price ? (
        <>
          <div>
          <Text
                              className={`  
                  !text-red-500  !line-through !font-normal
                  `}
                            >
                              <PriceFormatter
                                classNames="!text-red-500  !line-through !font-normal"
                               
                                inputPrice={price}
                              />
                            </Text>
          </div>
          <div>
            <Text className="text-lg !text-black">
              {priceWithDiscount === 0 ? (
                <Text className="!text-lg !text-green-500">Ücretsiz</Text>
              ) : (
                <PriceFormatter inputPrice={priceWithDiscount} />
              )}
            </Text>
          </div>
        </>
      ) : (
        <span className="!p-2 !rounded-md !bg-[#ffc600]">
          {price === 0 ? (
            <Text className="!text-lg !font-normal !text-black !mt-2">
              Ücretsiz
            </Text>
          ) : (
            <PriceFormatter inputPrice={price} />
          )}
        </span>
      )}
    </div>
  );
};

const Content: FC<{ selectedRecord: null | any }> = ({ selectedRecord }) => {
  const windowSize = useWindowSize();
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    if (windowSize.width < 1040) {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  }, []);
  const { Text } = Typography;
  const invoiceDetails = useGetInvoiceDetails(selectedRecord?.id);
  const invoiceDetailsData = invoiceDetails?.data?.data || null;
  const columns = [
    {
      title: "Başlık",
      dataIndex: ["package", "name"],
      key: "title",
      render: (value: string, record: any) => {
        return (
          <div className="!flex justify-between !w-full">
            <div className="!flex !flex-col gap-1">
              <div>
                <Text>{value}</Text>
              </div>

              <div className="!flex !flex-col gap-1 xl:!hidden">
                <div>
                  <Tag
                    className="!text-[8px] md:!text-sm"
                    color={record?.package?.isDoping ? "blue" : "warning"}
                  >
                    {record?.package?.isDoping ? "Doping" : "Paket"}
                  </Tag>
                </div>
                <div className="!flex !flex-col gap-0">
                  <div>
                    <Text className="mobile-label"></Text>
                  </div>
                 
                </div>
              </div>
            </div>
            <div>
            <div>

<PriceDisplay
  price={record?.price}
  priceWithDiscount={record?.package?.priceWithDiscount}
/>
</div>

            </div>
          </div>
        );
      },
    },
    ...(isSmallScreen
      ? []
      : [
          {
            title: "Paket Tipi",
            dataIndex: "paketTipi",
            key: "paketTipi",
            render: (_: any, record: any) => (
              <Tag color={record?.package?.isDoping ? "blue" : "warning"}>
                {record?.package?.isDoping ? "Doping" : "Paket"}
              </Tag>
            ),
          },
          {
            title: "Fiyat",
            dataIndex: ["package", "price"],
            key: "price",
            render: (price: number, item: any) => {
              return (
                <div className="!flex !flex-col gap-0">
                  <div>
                    <Text className="mobile-label" data-label="Fiyat"></Text>
                  </div>
                  <div></div>
                  <PriceDisplay
                    price={price}
                    priceWithDiscount={item?.package?.priceWithDiscount}
                  />
                </div>
              );
            },
          },
        ]),
  ];
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    if (invoiceDetailsData?.userPackage) {
      const newTotal = invoiceDetailsData.userPackage.reduce(
        (acc: number, item: any) =>
          acc + (item?.package?.priceWithDiscount ?? item?.package?.price ?? 0),
        0
      );
      setTotal(newTotal);
    }
  }, [invoiceDetailsData]);
  return (
    <>
      <Row>
        <Col xs={24}>
          <Table
            columns={columns}
            dataSource={invoiceDetails?.data?.data.userPackage || []}
            pagination={false}
          />
        </Col>
        <Col xs={24}>
          <div className="!flex justify-between  !w-full md:!p-4">
            <div>
              <div className=" !justify-start !hidden lg:!flex ">
                <LazyLoadImage
                  wrapperHeight="200px"
                  wrapperWidth="400px"
                  src="https://upload.wikimedia.org/wikipedia/commons/c/c6/%C4%B0mza.png"
                  alt=""
                  classNames="!relative"
                />
                <LazyLoadImage
                  wrapperHeight="50px"
                  wrapperWidth="50px"
                  src={SkeltonCartSvg}
                  alt=""
                  //   classNames="!absolute top-6 left-6"
                />
              </div>
              <div className="relative w-[50px] h-[50px] bg-[#FFC502] p-4 rounded-full shadow-lg !hidden lg:!flex">
                <Image
                  src={favIconUrl}
                  alt="loading"
                  width={"100%"}
                  height={"100%"}
                />
              </div>
            </div>
            <div className=" !border !border-gray-200 !p-4 !rounded-md !w-full md:!w-[300px] !mt-4 md:!mt-0">
              {invoiceDetailsData?.userPackage?.map((item: any) => {
                return (
                  <>
                    <div className="!flex justify-between items-center ">
                      <Text className="!text-sm ">{item?.package?.name}:</Text>
                      <PriceDisplay
                        price={item?.package?.price}
                        priceWithDiscount={item?.package?.priceWithDiscount}
                      />
                    </div>

                    <span className="mt-2 block h-1 w-100 bg-[#ffc600] sm:w-100 !mb-2"></span>
                  </>
                );
              })}

              <div className="!flex justify-between !mt-4">
                <Text className="!text-lg ">Toplam:</Text>
                <Text className="!text-xl !font-bold ">
                  {<PriceFormatter inputPrice={total} />}
                </Text>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Content;
